module.exports = __webpack_public_path__ + "img/sign.7fe4c56.svg";